import type { RadioButtonPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum RadioButtonSize {
  SMALL = 'small',
  BIG = 'big',
}

export type PassThroughMeridiaCheckbox =
  PassThrough<RadioButtonPassThroughOptions> & { label?: { class: string } };
